export default __webpack_public_path__ + "static/media/profiles-visited-Grey.cf11044d.svg";